export enum ActionTypes {
  GET_MATERIALS = 'materials/GET_MATERIALS',
  POST_MATERIAL = 'materials/POST_MATERIAL',
  EDIT_MATERIAL = 'materials/EDIT_MATERIAL',
  DELETE_MATERIAL = 'materials/DELETE_MATERIAL',
  GET_MATERIAL_GROUPS = 'material/GET_MATERIAL_GROUPS',
  GET_PROJECT_MATERIALS = 'materials/GET_PROJECT_MATERIALS',
  EDIT_PROJECT_MATERIAL = 'materials/EDIT_PROJECT_MATERIAL',
  DELETE_PROJECT_MATERIAL = 'materials/DELETE_PROJECT_MATERIAL',
  GET_MATERIALS_GROUPS = 'materials/GET_MATERIALS_GROUPS',
  EDIT_MATERIALS_GROUP = 'materials/EDIT_MATERIALS_GROUP',
  POST_MATERIALS_GROUP = 'materials/POST_MATERIALS_GROUP',
  GET_MATERIAL_ASSEMBLIES = 'materials/GET_MATERIAL_ASSEMBLIES',
  POST_MATERIAL_ASSEMBLY = 'materials/POST_MATERIAL_ASSEMBLY',
  EDIT_MATERIAL_ASSEMBLY = 'materials/EDIT_MATERIAL_ASSEMBLY',
  DELETE_MATERIAL_ASSEMBLY = 'materials/DELETE_MATERIAL_ASSEMBLY',
  GET_PROJECT_MATERIAL_ASSEMBLIES = 'materials/GET_PROJECT_MATERIAL_ASSEMBLIES',
  GET_PROJECT_TAKEOFF_QUANTITIES = 'materials/GET_PROJECT_TAKEOFF_QUANTITIES',
  GET_MATERIAL_PRICING = 'materials/GET_MATERIAL_PRICING',
  MATERIAL_PRICING_ADDED = 'materials/MATERIAL_PRICING_ADDED',
  EDIT_MATERIAL_PRICING = 'materials/EDIT_MATERIAL_PRICING',
  DELETE_MATERIAL_PRICING = 'materials/DELETE_MATERIAL_PRICING',
  GET_CREWS = 'materials/GET_CREWS',
  POST_CREW = 'materials/POST_CREW',
  EDIT_CREW = 'materials/EDIT_CREW',
  DELETE_CREW = 'materials/DELETE_CREW',
}
